module.exports = __webpack_public_path__ + "img/link_previous.6ec7ecc0.svg";